import React from 'react'
import { Badge, Grid, Box, Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import { numberFormatCurrency } from '@fedsim/helpers'

import HealthBar from '../../progress-bar';
import ImageBlock from '../../image-block'
import { Caption, HeaderTertiary, HeaderBody } from '../../typography'
import { NameBarStack } from '../../namebar'
import { SPACING, SpacedPaper } from '../../typography'

export const liSX = { width: '110px' }

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -3,
    top: 13,
    fontFamily: 'Open Sans',
    WebkitFontSmoothing: 'subpixel-antialiased',
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
    zIndex: 0
  }
}))

const BadgeUI = props => <StyledBadge {...props}
  color="secondary" />

export const WrestlerItemStats = ({
  morale = null,
  stamina = null,
  popularity = null,
  charisma = null,
  damage = null
}) => {
  return (
    <Grid container>
      <Grid item
        xs={6}>
        <HealthBar label="DMG"
          value={damage}
          backgroundColor="red"
          color="white" />
      </Grid>
      <Grid item
        xs={6}>
        <HealthBar label="STA"
          value={stamina} />
      </Grid>
      <Grid item
        xs={6}>
        <HealthBar label="POP"
          value={popularity} />
      </Grid>
      <Grid item
        xs={6}>
        <HealthBar label="MOR"
          value={morale} />
      </Grid>
      <Grid item
        xs={6}>
        <HealthBar label="CHAR"
          value={charisma} />
      </Grid>
    </Grid>
  )
}

export const WrestlerItem = ({
  name = '',
  image = false,
  alignment = null,
  backgroundColor = '',
  color = '',
  brands = [],
  cost = null,
  children = null,

  losses = 0,
  // draws = 0,
  wins = 0,
  streak = 0,

  charisma = null,
  stamina = null,
  morale = null,
  popularity = null,
  damage = null,
  points = 0
}) => {
  const alignmentLabel = alignment === "GOOD" ? "Goodie" : alignment === "BAD" ? "Baddie" : false

  return (
    <Box>
      <SpacedPaper sx={{
        minWidth: '350px', backgroundImage: 'radial-gradient(rgba(0, 0, 0, 0.4) 0.5px, transparent 0.5px)'  }}>
        <Stack spacing={2}
          sx={{
            color,
            width: '100%',
            alignItems: 'center',
            flexDirection: 'row',
            backgroundImage: 'radial-gradient(rgba(0, 0, 0, 0.4) 0.5px, transparent 0.5px)',
            backgroundSize: '15px 15px',
          }}>
          <BadgeUI badgeContent={points}>
            <ImageBlock image={image}
              backgroundColor={backgroundColor} />
          </BadgeUI>
          <Box>
            <Stack spacing={SPACING / 3}
              sx={{ marginLeft: 3, }}>
              <HeaderTertiary>{name}</HeaderTertiary>
              <Caption>
                {wins}W · {losses}L · {streak} streak
              </Caption>
              {alignmentLabel && (
                <HeaderBody>
                  {alignmentLabel}
                </HeaderBody>
              )}
              <NameBarStack brands={brands} />
              {cost && (
                <Caption>
                  {numberFormatCurrency(cost)} per appearance
                </Caption>
              )}
            </Stack>
          </Box>
        </Stack>
        {charisma || stamina || morale || popularity || damage ? (
          <Box my={0.5}>
            <WrestlerItemStats {...{ charisma, stamina, damage, morale, popularity }} />
          </Box>
        ) : null}
      </SpacedPaper>
      <Box>{children}</Box>
    </Box>
  )
}
